import socketPlugin from "@/plugins/socket";
import ChatService from "@/services/chatService";

const getDefaultState = () => ({
    chatRooms: [],
    activeRoom: {},
    socketConnected: false,
    userOnline:false,
    typingUsers: {},
    roomMessages:[],
    hasMoreMessages:true,
    hasMoreChats:true,
    activeTab:null,
    activeRoomNewMessage:false,
});

const state = getDefaultState();

const actions = {
      socketInitialize({commit, rootState}){
        const {location_id, client_id} = rootState.auth.user.data;
        const ProgramClientId = rootState.auth.user.data.id;
        const socket = socketPlugin.initializeSocket(location_id, client_id);
        //const _participant_id = rootState.auth.user.data.id;
        socket.on("connect", () => {
            console.log("Socket.IO connected:", socket.id);
            commit('SOCKET_STATUS', true);
        });

        socket.on("welcomeMessage", (data) => {
            console.log("event_welcomeMessage", data);
        });

        socket.on("user_status", (data) => {
            console.log('user status event: ', data);
        });

        socket.on("new_message", (data) =>{
            commit("ADD_NEW_MESSAGE", {newMessage: data, programClientId: ProgramClientId});
            commit("CHAT_ROOM_SORT", data);
        });

        socket.on("recent_chat_updated", (updatedChat) => {
            commit("RECENT_CHAT_RELOAD", {programClient:rootState.auth.user.data, recentRoomUpdate:updatedChat});
        });

        socket.on("new_chat_room", (newRoom) => {
            const participants = newRoom.participants;
            if (participants){
                const clientParticipant = participants.find((p) => p.participant_id === ProgramClientId && p.participant_type === 'App\\ProgramClient');
                if (clientParticipant){
                    newRoom.unread_count = clientParticipant.unread_count;
                    const roomExists = rootState.chat.chatRooms.find((r) => r.chat_room_id === newRoom.chat_room_id);
                    if (!roomExists){
                        commit('ADD_CHAT_ROOM', newRoom);
                    }else{
                        console.log('client new chat room already exists.');
                    }
                }
            }
        });

        socket.on("client_new_private_room", (eventData) => {
            const {chatRoom} = eventData;
            const joinRoom = {roomName: `${chatRoom.room_type}_${chatRoom.chat_room_id}`, user:`client_${client_id}`}
            socket.emit("joinRoom", joinRoom);
            commit('ADD_PRIVATE_ROOM', chatRoom);
        });

        socket.on("client_delete_private_room", (eventData) => {
            const {chatRoom} = eventData;
           commit("REMOVE_PRIVATE_ROOM", chatRoom);
        });

        socket.on("client_new_group_room", (eventData) => {
            const {chatRoom} = eventData;
            const joinRoom = {roomName: `${chatRoom.room_type}_${chatRoom.chat_room_id}`, user:`client_${client_id}`}
            socket.emit("joinRoom", joinRoom);
            commit('ADD_GROUP_ROOM', chatRoom);
        });

        socket.on("room_participant_changed", (roomChanged) => {
           console.log("room_participant_changed event fired", roomChanged);
        });

        socket.on("client_remove_group_room", (eventData) => {
            const {chatRoom} = eventData;
            commit("REMOVE_GROUP_ROOM", chatRoom);

        });

        socket.on("room_participant_unread_count", (eventData) => {
            commit("ACTIVE_CHAT_ROOM_UNREAD_COUNT_UPDATE", eventData);
        });

        // Listen for all events
        socket.onAny((event, ...args) => {
            console.log(`Event: ${event}`, args);
        });

        socket.on("error", (er) => {
            console.log('Error caught:', er);
        });

        socket.on("disconnect", () => {
            console.log("Socket.IO disconnected:", socket);
        });

        //heartbeat client with server
        setInterval(() => {
            //const userData = {userId: _participant_id, userType:'client'};
            //socket.emit('heartbeat', userData);
        }, 15000);
      },
      socketDisconnect({commit, rootState}){
        const socket = socketPlugin.getSocket();
        if (socket){
            socket.emit("user_offline", {user_id:rootState.auth.user.data.id, user_type:'client'});
            socket.disconnect();
            commit('SOCKET_STATUS', false);
        }
      },
      setActiveTab({commit}, tabName){
        commit('SET_ACTIVE_TAB', tabName);
      },
      async fetchClientRecentChat({commit, rootState}, payload){
        try{
            const {roomType, search, page} = payload;
            const programClient = rootState.auth.user.data;
            const response = await ChatService.getClientRecentChats(programClient.location_id, programClient.id, roomType, search, page);
            
            commit('SET_MORE_CHATS', (state.activeTab === roomType) ? response.data.totalPages - page : 1);
            commit('SET_CLIENT_RECENT_CHAT', response.data.data);
        }
        catch(err){
            commit('SET_CLIENT_RECENT_CHAT', []);
            console.log('Unable to fetch client recent chat request.');
        }
      },
      async fetchRoomMessagesById({commit, rootState}, {chatRoomId, page}){
        try{
            const programClient = rootState.auth.user.data;
            const response = await ChatService.getClientChatRoomMessagesByChatRoomId(programClient.location_id, programClient.id, chatRoomId, page);
            await commit('SET_CLIENT_ROOM_MESSAGES', {chatRoomId, roomMessages:response.data.data, append: page > 1});
            commit('SET_MORE_MESSAGES', response.data.totalPages - page);
        }catch(err){
            console.log('Unable to fetch room message request.');
        }
      },
      async sendClientMessage({commit, rootState}, payload){
        try{
            const programClient = rootState.auth.user.data;
            const response = await ChatService.postClientSendMessage(programClient.location_id, programClient.client_id, payload);
            const socket = socketPlugin.getSocket();
            if (socket){
                socket.emit("send_message", response.data);
            }
            commit('ADD_NEW_MESSAGE', response.data.message);

        }catch(err){
            console.log('Unable to send room message request.', err);
        }
      },
      socketSendMessage({commit}, payload){
        try{
            const socket = socketPlugin.getSocket();
            if (socket){
                socket.emit("send_message", payload);
                commit('ADD_NEW_MESSAGE', payload);
            }
        }catch(error){
            console.log('Unable to send message via socket.');
        }
      },
      setActiveChatRoom({commit}, chatRoom){
        commit('SET_ROOM', chatRoom);
      },
      async markAllMessageAsRead({commit, rootState}, payload){
        try{
            const programClient = rootState.auth.user.data;
            payload.participant_id = programClient.id;
            const response = await ChatService.postClientAllMessageRead(programClient.location_id, payload);
            commit('ALL_MESSAGE_READ', {chatRoomId: payload.chat_room_id, programClientId: payload.participant_id, message_id: response.data});

        }catch(error){
            console.log('Unable to send all message read request.', error);
        }
      },
      resetChatState({commit}){
        commit('RESET_STATE');
      },
      socketReadMessage({commit}, payload){
        try{
            const socket = socketPlugin.getSocket();
            if (socket){
                socket.emit("room_participant_message_read", payload);
                commit('ACTIVE_CHAT_ROOM_NEW_MESSAGE_ARRIVED', false);
            }

        }catch(error){
            console.log('Unable to mark read message via socket.');
        }
      }
};
const mutations = {
    SOCKET_STATUS(state, socketStatus){
        state.socketConnected = socketStatus;
    },
    SET_ACTIVE_TAB(state, tab){
        state.activeTab = tab;
    },
    SET_CLIENT_RECENT_CHAT(state, recentChatResponse){
        const merged = [...state.chatRooms];
        recentChatResponse.forEach((newChat) => {
            const roomExists = merged.find((chat) => chat.chat_room_id === newChat.chat_room_id);
            if (!roomExists){
                merged.push(newChat);
            }
        });
        merged.sort((a, b) => {
            const timeA = a.LastMessage?.created_at || a.last_activity_at;
            const timeB = b.LastMessage?.created_at || b.last_activity_at;
            return new Date(timeB) - new Date(timeA);
        });
        state.chatRooms = merged;
    },
    SET_ROOM(state, chatRoom){
        state.activeRoom = chatRoom
        state.roomMessages = [];
    },
    SET_CLIENT_ROOM_MESSAGES(state, {chatRoomId, roomMessages, append = false}){
        if (!state.roomMessages){
            state.roomMessages = [];
        }
        const reverseMessages = [...roomMessages].reverse();
        state.chatRooms.forEach((room, k) => {
            if (room.chat_room_id === chatRoomId){
                if (append && Array.isArray(room.messages)){
                    state.chatRooms[k].messages = [...reverseMessages, ...room.messages];
                }else{
                    state.chatRooms[k].messages = reverseMessages;
                }
                
            }
        });
        if (append && Array.isArray(state.roomMessages)){
            state.roomMessages = [...reverseMessages, ...state.roomMessages];    
        }else{
            state.roomMessages = reverseMessages;
        }
    },
    ADD_NEW_MESSAGE(state, {newMessage, programClientId}){
        if (!state.roomMessages){
            state.roomMessages = [];
        }
        const {chat_room_id} = newMessage;
        state.chatRooms.forEach((room, k) => {
            if (room.chat_room_id === chat_room_id){
                const isDuplicate = state.chatRooms[k].messages.some(msg => msg.id === newMessage.id);
                if (!isDuplicate){
                    state.chatRooms[k].messages.push(newMessage);
                    state.chatRooms[k].last_message = newMessage.message;
                    state.chatRooms[k].last_message_date_time = newMessage.created_at;
                }
                if (typeof newMessage.participants !== 'undefined'){
                    for (let participant of newMessage.participants){
                        if (participant.participant_id === programClientId){
                            state.chatRooms[k].unread_count = participant.unread_count;
                            if (state.activeRoom && state.activeRoom.chat_room_id === chat_room_id){
                                state.activeRoom.unread_count = participant.unread_count;
                            }
                            const roomParticipants = state.chatRooms[k].participants;
                            if (typeof roomParticipants !== 'undefined'){
                                const participantIndex = roomParticipants.findIndex(p => p.participant_id === programClientId && p.participant_type === 'App\\ProgramClient');
                                if (participantIndex !== -1){
                                    state.chatRooms[k].participants[participantIndex].unread_count = participant.unread_count;
                                }
                            }
                        }
                    }
                }
            }
        });
        if (state.activeRoom && state.activeRoom.chat_room_id === chat_room_id){
            const isExists = state.roomMessages.some(msg => msg.id === newMessage.id);
            if (!isExists){
                state.roomMessages.push(newMessage);
            }
            state.activeRoomNewMessage = true;
        }
    },
    ADD_MESSAGE(state, {message}){
        const {chat_room_id} = message;
        state.chatRooms.forEach((room, k) => {
            if (room.chat_room_id === chat_room_id){
                const isDuplicate = state.recentChats[k].messages.some(msg => msg.id === message.id);
                if (!isDuplicate){
                    state.chatRooms[k].messages.push(message);
                    state.chatRooms[k].last_message = message.message;
                }
            }
        });
    },
    RECENT_CHAT_RELOAD(state, {programClient, recentRoomUpdate}){
        const index = state.chatRooms.findIndex( c => c.chat_room_id === recentRoomUpdate.chat_room_id);
        if (index !== -1){
            const participant = recentRoomUpdate.participants.find( p => p.chat_room_id === recentRoomUpdate.chat_room_id && p.participant_id === programClient.id);
            if (participant){
                state.chatRooms[index].unread_count = participant.unread_count;
            }
            const updatedRoom = state.chatRooms[index];
            state.chatRooms.splice(index, 1);
            state.chatRooms.unshift(updatedRoom);
        }else{
            state.chatRooms.unshift(recentRoomUpdate);
        }
    },
    SET_MORE_MESSAGES(state, noOfPages){
        state.hasMoreMessages = (noOfPages > 0);
    },
    SET_MORE_CHATS(state, noOfPages){
        state.hasMoreChats = (noOfPages > 0);
    },
    ALL_MESSAGE_READ(state, {chatRoomId, programClientId, message_id}){
        state.chatRooms.forEach((room, k) => {
            if (room.chat_room_id === chatRoomId){
                state.chatRooms[k].unread_count = 0;
                const participants = state.chatRooms[k].participants;
                if (typeof participants !== 'undefined'){
                    const participantIndex = state.chatRooms[k].participants.findIndex(p => p.participant_id === programClientId && p.participant_type === 'App\\ProgramClient');
                    if (participantIndex !== -1){
                        state.chatRooms[k].participants[participantIndex].unread_count = 0;
                    }
                }
            }
        });
        console.log(message_id);
    },
    ADD_CHAT_ROOM(state, newChatRoom){
        state.chatRooms.unshift(newChatRoom);
        state.activeRoom = newChatRoom;
    },
    CHAT_ROOM_SORT(state, data){
        const roomIndex = state.chatRooms.findIndex( c => c.chat_room_id === data.chat_room_id);
            if (roomIndex !== -1){
                const changedRoom = state.chatRooms[roomIndex];
                state.chatRooms.splice(roomIndex, 1);
                state.chatRooms.unshift(changedRoom);
            }
    },
    ADD_PRIVATE_ROOM(state, newChatRoom){
        let isRoomExists = state.chatRooms.findIndex((cr) => cr.chat_room_id === newChatRoom.chat_room_id);
        if (isRoomExists === -1){
            state.chatRooms.unshift(newChatRoom);
        }
    },
    ADD_GROUP_ROOM(state, newGroupRoom){
        let groupRoomFound = state.chatRooms.findIndex((g) => g.chat_room_id === newGroupRoom.chat_room_id);
        if (groupRoomFound === -1){
            state.chatRooms.unshift(newGroupRoom);
        }
    },
    REMOVE_PRIVATE_ROOM(state, deletedRoom){
        let roomIndex = state.chatRooms.findIndex((r) => r.chat_room_id === deletedRoom.chat_room_id);
        if (roomIndex !== -1){
            if (state.activeRoom.chat_room_id === deletedRoom.chat_room_id){
                state.activeRoom = {};
            }
            state.chatRooms.splice(roomIndex, 1);
        }
    },
    REMOVE_GROUP_ROOM(state, chatRoom){
        let roomIndex = state.chatRooms.findIndex((r) => r.chat_room_id === chatRoom.chat_room_id);
        if (roomIndex !== -1){
            if (state.activeRoom.chat_room_id === chatRoom.chat_room_id){
                state.activeRoom = {};
            }
            state.chatRooms.splice(roomIndex, 1);
        }
    },
    ACTIVE_CHAT_ROOM_NEW_MESSAGE_ARRIVED(state, isNewMessageArrived){
        state.activeRoomNewMessage = isNewMessageArrived;
    },
    ACTIVE_CHAT_ROOM_UNREAD_COUNT_UPDATE(state, data){
        const activeRoomIndex = state.chatRooms.findIndex( c => c.chat_room_id === data.chat_room_id);
        if (activeRoomIndex !== -1){
            state.chatRooms[activeRoomIndex].unread_count = data.unread_count;
            const roomParticipant = state.chatRooms[activeRoomIndex].participants.findIndex( p => p.participant_id === data.participant_id && p.participant_type === 'App\\ProgramCoach');
            if (roomParticipant !== -1){
                state.chatRooms[activeRoomIndex].participants[roomParticipant].unread_count = data.unread_count;
            }
        }
        if (state.activeRoom){
            const roomParticipant = state.activeRoom.participants.findIndex(p => p.participant_id === data.participant_id && p.participant_type === 'App\\ProgramClient');
            if (roomParticipant !== -1){
                state.activeRoom.participants[roomParticipant].unread_count = data.unread_count;
            }
        }
    },
    RESET_STATE(state){
        Object.assign(state, getDefaultState());
    }

};

const getters = {
    chatRooms: (state) => state.chatRooms,
    socketConnected: (state) => state.socketConnected,
    chatRoomMessages: (state) => state.roomMessages,
    activeRoom : (state) => state.activeRoom,
    hasMoreMessagePage: (state) => state.hasMoreMessages,
    hasMoreChatPage: (state) => state.hasMoreChats,
    chatActiveTab: (state) => state.activeTab,
    activeChatRoomNewMessageArrived: (state) => state.activeRoomNewMessage
};

export default {
     state, 
     mutations, 
     actions, 
     getters
    };